document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.yoka-menu-toggle');
  const nav = document.querySelector('#YokaMobileNav');

  if (toggle && nav) {
    const closeMenu = () => {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Abrir menú');
      nav.classList.remove('is-open');
    };

    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      toggle.setAttribute('aria-label', open ? 'Abrir menú' : 'Cerrar menú');
      nav.classList.toggle('is-open', !open);
    });

    nav.addEventListener('click', (event) => event.stopPropagation());
    document.addEventListener('click', closeMenu);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu();
    });

    nav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeMenu);
    });
  }

  const updateCartCount = (count) => {
    document.querySelectorAll('.yoka-cart__count').forEach((el) => {
      el.textContent = count;
    });
  };

  document.querySelectorAll('[data-yoka-quick-cart]').forEach((form) => {
    const qtyInput = form.querySelector('input[name="quantity"]');
    const minus = form.querySelector('[data-yoka-minus]');
    const plus = form.querySelector('[data-yoka-plus]');
    const button = form.querySelector('button[type="submit"]');
    const message = form.querySelector('.yoka-quick-cart__message');
    const variantSelect = form.querySelector('[data-yoka-variant-select]');

    const getQty = () => {
      const value = parseInt(qtyInput.value, 10);
      return Number.isFinite(value) && value > 0 ? value : 1;
    };

    if (variantSelect && button) {
      variantSelect.addEventListener('change', () => {
        const selected = variantSelect.options[variantSelect.selectedIndex];
        const variantId = selected && selected.value;
        button.disabled = !variantId;
        button.style.opacity = variantId ? '1' : '.45';
        button.style.cursor = variantId ? 'pointer' : 'not-allowed';
        if (variantId) {
          button.innerHTML = '<span aria-hidden="true">🛒</span> Agregar';
        } else {
          button.innerHTML = '<span aria-hidden="true">🛒</span> Selecciona talla';
        }
      });
    }

    if (minus) {
      minus.addEventListener('click', () => {
        qtyInput.value = Math.max(1, getQty() - 1);
      });
    }

    if (plus) {
      plus.addEventListener('click', () => {
        qtyInput.value = getQty() + 1;
      });
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!button) return;
      if (variantSelect && !variantSelect.value) {
        variantSelect.focus();
        return;
      }

      const original = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Agregando…';
      if (message) message.textContent = '';

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });

        if (!response.ok) throw new Error('No se pudo agregar');

        const cartResponse = await fetch('/cart.js', {
          headers: { 'Accept': 'application/json' }
        });
        const cart = await cartResponse.json();

        updateCartCount(cart.item_count);
        if (message) message.textContent = 'Agregado al carrito';
        button.textContent = '✓ Agregado';

        setTimeout(() => {
          button.innerHTML = original;
          button.disabled = false;
          if (variantSelect) {
            variantSelect.value = '';
            button.innerHTML = '<span aria-hidden="true">🛒</span> Selecciona talla';
            button.style.opacity = '.45';
            button.style.cursor = 'not-allowed';
          }
          if (message) message.textContent = '';
        }, 1400);
      } catch (error) {
        button.innerHTML = original;
        button.disabled = false;
        if (variantSelect && !variantSelect.value) {
          button.innerHTML = '<span aria-hidden="true">🛒</span> Selecciona talla';
          button.style.opacity = '.45';
          button.style.cursor = 'not-allowed';
        }
        if (message) message.textContent = 'No se pudo agregar. Inténtalo de nuevo.';
      }
    });
  });
});

(function(){
  function initYokaCarousel(root){
    if(!root || root.dataset.ready==='1') return;
    root.dataset.ready='1';
    const slides=[...root.querySelectorAll('.ys-hero__slide')], dots=[...root.querySelectorAll('[data-dot]')]; let index=0,timer;
    function show(i){index=(i+slides.length)%slides.length;slides.forEach((s,n)=>s.classList.toggle('is-active',n===index));dots.forEach((d,n)=>d.setAttribute('aria-selected',n===index?'true':'false'));}
    function restart(){clearInterval(timer);timer=setInterval(()=>show(index+1),5500)}
    root.querySelector('[data-next]')?.addEventListener('click',()=>{show(index+1);restart()});root.querySelector('[data-prev]')?.addEventListener('click',()=>{show(index-1);restart()});dots.forEach((d,n)=>d.addEventListener('click',()=>{show(n);restart()}));
    let startX=0;root.addEventListener('touchstart',e=>startX=e.changedTouches[0].clientX,{passive:true});root.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-startX;if(Math.abs(dx)>40){show(index+(dx<0?1:-1));restart()}},{passive:true});restart();
  }
  document.addEventListener('DOMContentLoaded',()=>initYokaCarousel(document.querySelector('[data-yoka-carousel]')));
})();

/* YOKA SPORT — selector Color > Talla para variantes Color / Talla */
(function(){
  function initYokaColorSizePicker(){
    document.querySelectorAll('.yoka-size-picker').forEach(function(picker){
      if(picker.dataset.yokaColorSizeReady==='1') return;
      var grid=picker.querySelector('.yoka-size-picker__grid');
      if(!grid) return;
      var originalButtons=Array.from(grid.querySelectorAll('[data-yoka-variant-button]'));
      if(!originalButtons.length) return;
      var parsed=originalButtons.map(function(button){
        var parts=(button.textContent||'').split('/').map(function(part){return part.trim();}).filter(Boolean);
        return {button:button,color:parts.length>=2?parts[0]:'',size:parts.length>=2?parts.slice(1).join(' / '):(parts[0]||'')};
      });
      var hasColorSize=parsed.some(function(item){return item.color && /^(?:3[5-9]|4[0-9]|50)$/.test(item.size);});
      if(!hasColorSize) return;
      picker.dataset.yokaColorSizeReady='1';
      var colorWrap=document.createElement('div');
      colorWrap.className='yoka-color-picker';
      colorWrap.innerHTML='<div class="yoka-color-picker__head"><strong>Color</strong><span>Selecciona un color</span></div><div class="yoka-color-picker__grid"></div>';
      var colorGrid=colorWrap.querySelector('.yoka-color-picker__grid');
      var colorMap={};
      parsed.forEach(function(item){if(!item.color)return;var key=item.color.toLowerCase();if(!colorMap[key])colorMap[key]={label:item.color,items:[]};colorMap[key].items.push(item);});
      Object.keys(colorMap).forEach(function(key){
        var group=colorMap[key];
        var colorButton=document.createElement('button');
        colorButton.type='button';colorButton.className='yoka-color-button';colorButton.dataset.yokaColor=group.label;colorButton.textContent=group.label;
        if(!group.items.some(function(item){return !item.button.disabled;}))colorButton.disabled=true;
        colorButton.addEventListener('click',function(){
          if(colorButton.disabled)return;
          var available=group.items.filter(function(item){return !item.button.disabled;});if(!available.length)return;
          document.querySelectorAll('.yoka-color-button').forEach(function(btn){btn.classList.remove('is-selected');});
          colorButton.classList.add('is-selected');
          parsed.forEach(function(item){item.button.hidden=!item.color||item.color.toLowerCase()!==key;item.button.classList.remove('is-selected');});
          var current=available[0];current.button.hidden=false;current.button.click();
        });
        colorGrid.appendChild(colorButton);
      });
      grid.classList.add('yoka-size-picker__grid--filtered');
      var firstSelected=parsed.find(function(item){return item.button.classList.contains('is-selected')&&!item.button.disabled;});
      var initialColor=firstSelected&&firstSelected.color?firstSelected.color.toLowerCase():Object.keys(colorMap)[0];
      parsed.forEach(function(item){item.button.textContent=item.size;item.button.hidden=!item.color||item.color.toLowerCase()!==initialColor;item.button.setAttribute('aria-label','Talla '+item.size+' · '+item.color);});
      picker.insertBefore(colorWrap,grid);
      var initialColorButton=Array.from(colorGrid.querySelectorAll('.yoka-color-button')).find(function(btn){return btn.dataset.yokaColor.toLowerCase()===initialColor;});
      if(initialColorButton)initialColorButton.classList.add('is-selected');
      var initialSize=parsed.find(function(item){return item.color&&item.color.toLowerCase()===initialColor&&item.button.classList.contains('is-selected')&&!item.button.disabled;})||parsed.find(function(item){return item.color&&item.color.toLowerCase()===initialColor&&!item.button.disabled;});
      if(initialSize)initialSize.button.click();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initYokaColorSizePicker);else initYokaColorSizePicker();
  document.addEventListener('shopify:section:load',initYokaColorSizePicker);
})();